export default __webpack_public_path__ + "static/step_1_ru-118002cfe3d0cc9a32f565b775246a07.svg";